import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import type { UpdatePlatformSettingsDto } from '../types/platform-settings.types';

export const usePlatformSettingsUpdateMutation = (onSuccess?: () => void) => {
    const axiosInstance = useAxiosAuth();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (body: UpdatePlatformSettingsDto) => {
            await axiosInstance.put(
                ApiConfig.queries.superAdmin.platformSettings.endpoints.update,
                body,
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [ApiConfig.queries.superAdmin.platformSettings.queryKeys.get],
            });
            onSuccess?.();
        },
    });
};
